// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.libraries-container {
  display: inline-block;
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-radius: 56px;
  padding: 8px 10px;
  margin: 15px 15px 0;
}
@media (max-width: 320px) {
  .libraries-container {
    font-size: 12px;
    padding: 0 8px;
  }
}

.more-options {
  margin-left: 4px;
  cursor: pointer;
}

.city-checkbox {
  margin: 8px;
}

.no-city-warning {
  background-color: #fffaf3;
  color: #573a08;
  box-shadow: 0 0 0 1px #c9ba9b inset, 0 0 0 0 transparent;
  padding: 0.3rem;
  color: rgba(0, 0, 0, 0.87);
  width: 16rem;
  margin: 1rem auto 0;
}
.no-city-warning .icon {
  margin-right: 0.2em;
  line-height: 1;
  font-size: 1.5em;
  opacity: 0.8;
  display: inline-block;
  vertical-align: middle;
}
.no-city-warning .content {
  text-align: left;
  display: inline-block;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/Components/CityCheckbox/CityCheckbox.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AACF;AACE;EAPF;IAQI,eAAA;IACA,cAAA;EAEF;AACF;;AACA;EACE,gBAAA;EACA,eAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,yBAAA;EACA,cAAA;EACA,wDAAA;EACA,eAAA;EACA,0BAAA;EACA,YAAA;EACA,mBAAA;AAEF;AAAE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;AAEJ;AACE;EACE,gBAAA;EACA,qBAAA;EACA,sBAAA;AACJ","sourcesContent":[".libraries-container {\n  display: inline-block;\n  border: 2px solid rgba(0, 0, 0, 0.2);\n  border-radius: 56px;\n  padding: 8px 10px;\n  margin: 15px 15px 0;\n\n  @media (max-width: 320px) {\n    font-size: 12px;\n    padding: 0 8px;\n  }\n}\n\n.more-options {\n  margin-left: 4px;\n  cursor: pointer;\n}\n\n.city-checkbox {\n  margin: 8px;\n}\n\n.no-city-warning {\n  background-color: #fffaf3;\n  color: #573a08;\n  box-shadow: 0 0 0 1px #c9ba9b inset, 0 0 0 0 transparent;\n  padding: 0.3rem;\n  color: rgba(0, 0, 0, 0.87);\n  width: 16rem;\n  margin: 1rem auto 0;\n\n  .icon {\n    margin-right: 0.2em;\n    line-height: 1;\n    font-size: 1.5em;\n    opacity: 0.8;\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  .content {\n    text-align: left;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
